import { cn } from "~/lib/utils";

// // // //

const STATUS_CONFIG: Record<
    string,
    { label: string; dot: string; text: string; bg: string; ring: string }
> = {
    active: {
        label: "Active",
        dot: "bg-green-500",
        text: "text-green-700 dark:text-green-400",
        bg: "bg-green-500/10",
        ring: "ring-green-500/20",
    },
    revoked: {
        label: "Revoked",
        dot: "bg-destructive",
        text: "text-destructive",
        bg: "bg-destructive/10",
        ring: "ring-destructive/20",
    },
    disabled: {
        label: "Disabled",
        dot: "bg-muted-foreground",
        text: "text-muted-foreground",
        bg: "bg-muted",
        ring: "ring-border",
    },
};

const FALLBACK_CONFIG = {
    dot: "bg-muted-foreground",
    text: "text-muted-foreground",
    bg: "bg-muted",
    ring: "ring-border",
};

/**
 * OauthClientStatusBadge
 * Renders a colored dot-pill status badge for an OAuth client or secret status.
 */
export function OauthClientStatusBadge(props: { status: string }) {
    const { status } = props;
    const config = STATUS_CONFIG[status] ?? {
        ...FALLBACK_CONFIG,
        label: status,
    };

    return (
        <span
            className={cn(
                "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset",
                config.bg,
                config.text,
                config.ring,
            )}
        >
            <span
                className={cn("size-1.5 rounded-full", config.dot)}
                aria-hidden="true"
            />
            {config.label}
        </span>
    );
}
